/* eslint-disable no-unused-vars */
import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import * as S from './IconButton.styled';

const btnTypes = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
  internal: 'internal',
};

const NormalSize = forwardRef(
  (
    {
      icon,
      onClick,
      disabled,
      type,
      isPressed,
      isDefaultMuted,
      isDestructive,
      btnSize = '40px',
      iconSize = '24px',
      id,
      name,
      style,
    },
    ref,
  ) => {
    return (
      <S.ContainerNormalSize
        style={style}
        id={id}
        name={name}
        btnSize={btnSize}
        iconSize={iconSize}
        onClick={onClick}
        disabled={disabled}
        type='button'
        visualType={type}
        pressed={isPressed}
        isDefaultMuted={isDefaultMuted}
        isDestructive={isDestructive}
        ref={ref}
      >
        {icon()}
      </S.ContainerNormalSize>
    );
  },
);
NormalSize.displayName = 'NormalSize';

const SmallSize = forwardRef(
  (
    {
      icon,
      onClick,
      disabled,
      type,
      isDefaultMuted,
      isDestructive,
      btnSize = '32px',
      iconSize = '16px',
      style,
      isPressed,
      id,
    },
    ref,
  ) => {
    return (
      <NormalSize
        id={id}
        style={style}
        isDestructive={isDestructive}
        isDefaultMuted={isDefaultMuted}
        type={type}
        icon={icon}
        disabled={disabled}
        onClick={onClick}
        btnSize={btnSize}
        iconSize={iconSize}
        ref={ref}
        isPressed={isPressed}
      />
    );
  },
);
SmallSize.displayName = 'SmallSize';

const Micro = forwardRef(
  (
    {
      icon,
      onClick,
      disabled,
      type,
      isDefaultMuted,
      isDestructive,
      btnSize = '24px',
      iconSize = '16px',
      style,
      isPressed,
      id,
    },
    ref,
  ) => {
    return (
      <NormalSize
        id={id}
        style={style}
        isDestructive={isDestructive}
        isDefaultMuted={isDefaultMuted}
        type={type}
        icon={icon}
        disabled={disabled}
        onClick={onClick}
        btnSize={btnSize}
        iconSize={iconSize}
        ref={ref}
        isPressed={isPressed}
      />
    );
  },
);
Micro.displayName = 'Micro';

const SmallSizeBigIcon = forwardRef(
  (
    {
      icon,
      onClick,
      disabled,
      type,
      isDefaultMuted,
      isDestructive,
      btnSize = '32px',
      iconSize = '24px',
      style,
      isPressed,
      id,
    },
    ref,
  ) => {
    return (
      <NormalSize
        id={id}
        style={style}
        isDestructive={isDestructive}
        isDefaultMuted={isDefaultMuted}
        type={type}
        icon={icon}
        disabled={disabled}
        onClick={onClick}
        btnSize={btnSize}
        iconSize={iconSize}
        ref={ref}
        isPressed={isPressed}
      />
    );
  },
);
SmallSizeBigIcon.displayName = 'SmallSizeBigIcon';

export const IconButton = {
  NormalSize,
  SmallSize,
  Micro,
  SmallSizeBigIcon,
  btnTypes,
};

NormalSize.propTypes = {
  iconSize: PropTypes.oneOf(['16px', '24px']),
  btnSize: PropTypes.oneOf(['32px', '40px', '24px']),
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  icon: PropTypes.func.isRequired,
  isDestructive: PropTypes.bool,
  isDefaultMuted: PropTypes.bool,
  type: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'internal']),
};
